import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../../../shared/models/response.model';
import { FamilleLivrables } from '../models/famille-livrables.model';
import { FamilleLivrablesCreateRequest } from '../requests/famille-livrables-create-request';
import { FamilleLivrablesUpdateRequest } from '../requests/famille-livrables-update-request';

@Injectable({
  providedIn: 'root',
})
export class FamilleLivrablesService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/familles-livrables';

  trouverParId(idFamilleLivrables: string): Observable<FamilleLivrables> {
    return this.#http.get<FamilleLivrables>(this.BASE_URL + '/' + idFamilleLivrables);
  }

  trouverTous(idCartographie: string, idRéférentiel?: string) {
    let params = new HttpParams().append('idCartographie', idCartographie);

    if (idRéférentiel) params = params.append('idReferentiel', idRéférentiel);

    return this.#http.get<Response<FamilleLivrables>>(this.BASE_URL, { params });
  }

  créer(data: FamilleLivrablesCreateRequest) {
    return this.#http.post<void>(this.BASE_URL, data);
  }

  modifier(idFamilleLivrables: string, data: FamilleLivrablesUpdateRequest) {
    return this.#http.put<string>(this.BASE_URL + '/' + idFamilleLivrables, data);
  }

  supprimer(idFamilleLivrables: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idFamilleLivrables);
  }
}
